import GraphqlClient from './GraphqlClients';
import gql from 'graphql-tag';

export const registeredParsersQuery = gql`
  query RegisteredParsers($country: String) {
    parsers: parser_registeredParsers(country: $country) {
      documentType
      infoProvider
      formatType
    }
  }
`;

export const parserVersionsQuery = gql`
  query ParserVersions($documentType: String!, $infoProvider: String!, $formatType: String) {
    versions: parser_parserVersions(
      documentType: $documentType
      infoProvider: $infoProvider
      formatType: $formatType
    ) {
      id
      version
      validFrom
      validTo
    }
  }
`;

export const bulkReparseCandidatesCountQuery = gql`
  query BulkReparseCandidatesCount($filter: parser_BulkReparseFilterInput!) {
    count: parser_bulkReparseCandidatesCount(filter: $filter)
  }
`;

export const bulkReparseJobQuery = gql`
  query BulkReparseJob($id: String!) {
    job: parser_bulkReparseJob(id: $id) {
      id
      status
      totalCount
      processedCount
      succeededCount
      failedCount
      createdBy
      createdAt
      updatedAt
    }
  }
`;

const BulkReparseService = () => {
  const gqlClient = GraphqlClient();

  const bulkReparseMutation = gql`
    mutation BulkReparse($filter: parser_BulkReparseFilterInput!, $createdBy: String) {
      operation: parser_bulkReparse(filter: $filter, createdBy: $createdBy) {
        bulkReparseJob {
          id
          status
        }
      }
    }
  `;

  const getParserVersions = (documentType, infoProvider, formatType = 'default') =>
    gqlClient
      .query({
        query: parserVersionsQuery,
        variables: { documentType, infoProvider, formatType },
        fetchPolicy: 'network-only'
      })
      .then((data) => data.data.versions || []);

  const getBulkReparseCandidatesCount = (filter) =>
    gqlClient
      .query({
        query: bulkReparseCandidatesCountQuery,
        variables: { filter },
        fetchPolicy: 'network-only'
      })
      .then((data) => data.data.count);

  const bulkReparse = (filter, createdBy) =>
    gqlClient
      .mutate({ mutation: bulkReparseMutation, variables: { filter, createdBy } })
      .then((data) => data.data.operation.bulkReparseJob);

  const getBulkReparseJob = (id) =>
    gqlClient
      .query({ query: bulkReparseJobQuery, variables: { id }, fetchPolicy: 'network-only' })
      .then((data) => data.data.job)
      .catch(() => null);

  return {
    getParserVersions,
    getBulkReparseCandidatesCount,
    bulkReparse,
    getBulkReparseJob
  };
};

export default BulkReparseService;
